module.exports = __webpack_public_path__ + "img/tel-customer.d6a98ed4.png";